module.exports = __webpack_public_path__ + "img/stimulate.c637e7e2.png";